



















































































import BaseComponent from '@/core/base.component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import companyDistrictService from '@/services/company-district.service';
import amenityService from '@/services/amenity.service';
import { SpaceTypeCreateDto } from '@/dto/company-district';
import { AmenityDto } from '@/dto/amenity/amenity.dto';
@Component({
  name: 'SpaceTypeCreateDialog',
})
export default class SpaceTypeCreateDialog extends BaseComponent {
  @Prop({ required: true }) readonly dialog: boolean;

  private spaceCreateDto = new SpaceTypeCreateDto();
  private kitchenFacilityList: AmenityDto[] = [];
  private loading = false;
  private createLoading = false;
  private amenityArr = [];

  toggle() {
    this.$emit('update:dialog', !this.dialog);
    this.reset();
  }

  getAmenityList() {
    amenityService.findkitchenFacility().subscribe(res => {
      this.kitchenFacilityList = res.data;
    });
  }
  reset() {
    this.spaceCreateDto = new SpaceTypeCreateDto();
    this.amenityArr = [];
  }
  create() {
    this.createLoading = true;
    this.spaceCreateDto.amenityIds = this.amenityArr;
    this.spaceCreateDto.companyDistrictNo = this.$route.params.id;
    companyDistrictService
      .createDistrictSpaceType(this.spaceCreateDto)
      .subscribe(res => {
        if (res) {
          this.createLoading = false;
          this.$toasted.global.custom_success({ message: '생성 성공!' });
          this.toggle();
          this.$emit('created');
        } else {
          this.createLoading = false;
        }
      });
  }
  created() {
    this.getAmenityList();
  }
}
